import { render, staticRenderFns } from "./GraficoTopConjuntosComMaisErrosPorMetodologia.vue?vue&type=template&id=c3b59518&"
import script from "./GraficoTopConjuntosComMaisErrosPorMetodologia.vue?vue&type=script&lang=js&"
export * from "./GraficoTopConjuntosComMaisErrosPorMetodologia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
